// React
import React from 'react';

// Graphql
import { compose } from 'react-apollo';

// Translate
import { translate } from 'react-i18next';

// Style
import './style.sass';

// Components
import HomeButtonSeparator from '../../Home/components/HomeButtonSeparator';

// Images
const bgFifth = require('assets/images/NewDesign/Home/fifth-section/bg-fifth-2.png');
const emailIcon = require('assets/images/NewDesign/Home/fifth-section/fifth-icon/email.svg');
const wspIcon = require('assets/images/NewDesign/Home/fifth-section/fifth-icon/whatsapp.svg');
const twitterIcon = require('assets/images/NewDesign/Home/fifth-section/fifth-icon/twitter.svg');
const facebookIcon = require('assets/images/NewDesign/Home/fifth-section/fifth-icon/facebook.svg');
const instagramIcon = require('assets/images/NewDesign/Home/fifth-section/fifth-icon/instagram.svg');
const linkedinIcon = require('assets/images/NewDesign/Home/fifth-section/fifth-icon/linkedin.svg');
const sideHexPanal = require('assets/images/NewDesign/contact/section-panal-hex/side-hex-contact.png');

const homeLinkButtonURL = 'https://calendly.com/c1do1/30min';
class ContactSection extends React.Component {
  render() {
    const { t, href } = this.props;

    return (
      <div
        className='fifth-section-wrapper'
        style={{ backgroundImage: `url(${bgFifth})` }}
      >
        <img
          src={sideHexPanal}
          alt='fifth-side-hex-contact'
          className='fifth-side-hex-contact'
        />
        <div className='fifth-content-container'>
          {/* <p className='fifth-title'>{t('c1do1Black.contactSection.title')}</p> */}

          <div className='fifth-contact-container'>
            <HomeButtonSeparator t={t} href={homeLinkButtonURL} />
          </div>

          <div className='fifth-icon-container'>
            <ul>
              <a
                target='_blank'
                href='https://twitter.com/c1do12'
                rel='noopener noreferrer'
              >
                <li>
                  <img src={twitterIcon} alt='' />
                </li>
              </a>
              <a
                target='_blank'
                href='https://www.facebook.com/C1DO1-114970699873865/'
                rel='noopener noreferrer'
              >
                <li>
                  <img src={facebookIcon} alt='' />
                </li>
              </a>
              <a
                target='_blank'
                href='https://www.instagram.com/c1do1/'
                rel='noopener noreferrer'
              >
                <li>
                  <img src={instagramIcon} alt='' />
                </li>
              </a>
              <a
                target='_blank'
                href='https://www.linkedin.com/company/c1do1/'
                rel='noopener noreferrer'
              >
                <li>
                  <img src={linkedinIcon} alt='' />
                </li>
              </a>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(translate('common'))(ContactSection);
